export const DEFAULT_VIEWPORT_ACCESS_BREAKPOINT = 1024;

export type ViewportAccessState = {
  shouldShowLandscapeModal: boolean;
  shouldShowSmallScreenModal: boolean;
  isAllowed: boolean;
};

export function getViewportAccessState(
  minWidth = DEFAULT_VIEWPORT_ACCESS_BREAKPOINT,
): ViewportAccessState {
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const isPortrait =
    window.matchMedia("(orientation: portrait)").matches ||
    viewportHeight >= viewportWidth;

  if (viewportWidth >= minWidth) {
    return {
      shouldShowLandscapeModal: false,
      shouldShowSmallScreenModal: false,
      isAllowed: true,
    };
  }

  const canMeetRequirementByRotating = isPortrait && viewportHeight >= minWidth;

  return {
    shouldShowLandscapeModal: canMeetRequirementByRotating,
    shouldShowSmallScreenModal: !canMeetRequirementByRotating,
    isAllowed: false,
  };
}
